import * as Yup from "yup";

export const EditSchema = Yup.object().shape({
  id: Yup.string().required("Please select licence type"),
});
